module.exports = __webpack_public_path__ + "img/bgProNew.096df0ab.png";